import { createContext, useContext } from 'react';
import { UserDataContextType } from './types';

export const UserDataContext = createContext<UserDataContextType>({
  userData: null,
  isUserDataLoading: false,
  initInfo: null,
});

export const useUserDataContext = () => {
  const contextValue = useContext(UserDataContext);
  if (!contextValue) {
    throw new Error('UserDataContext.Provider is not found in tree');
  }
  return contextValue;
};
